module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-down-right-5.ad6d0a53.png";